export const authActions = {
    LOADING: "LOADING",
    ERROR: "ERROR",
    LOGOUT: "LOGOUT",
    AUTH: "AUTH",
}

export const notesActions = {
    LOADING: "LOADING",
    ADD_NOTES: "ADD_NOTES",
    GET_NOTES:"GET_NOTES",
    DELETE_NOTES:"DELETE_NOTES",
    EDIT_NOTES:"EDIT_NOTES",
    ERROR: "ERROR",
    ARCHIVE_NOTES:"ARCHIVE_NOTES",
    TRASH_NOTES:"TRASH_NOTES",
    GET_ARCHIVE:"GET_ARCHIVE",
    ARCHIVE_TO_TRASH:"ARCHIVE_TO_TRASH",
    RESTORE_ARCHIVE:"RESTORE_ARCHIVE", 
    GET_TRASH:"GET_TRASH",
    RESTORE_TRASH:"RESTORE_TRASH",
    DELETE_TRASH:"DELETE_TRASH",  
}

export const filterActions={
    SORT_BY_DATE:"SORT_BY_DATE",
    SORT_BY_PRIORITY:"SORT_BY_PRIORITY",
    SEARCH_NOTES:"SEARCH_NOTES",
    FILTER_BY_TAGS:"FILTER_BY_TAGS",
    CLEAR_ALL:"CLEAR_ALL"
}